import React, { useState, useRef } from 'react';
import CountryCard from './CountryCard';
import StripeFeeCard from './StripeFeeCard';
import TermsCard from './TermsCard';
import Tabs from 'components/ui/Tabs';
import { StyledButton } from 'components/forms/Buttons';
import { Spinner } from 'react-bootstrap';

interface TabItem {
  label: string;
  id: number;
  key: string;
  showCount?: boolean;
}

export interface SettingsCardProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  onCloseHandler: (flag: string) => void;
}

const Settings = () => {
  const [activeTab, setActiveTab] = useState('countries');
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  // Create refs for components that need form reset
  const termsCardRef = useRef<{ resetFormState: () => void }>(null);
  const countryCardRef = useRef<{ resetFormState: () => void }>(null);

  const onCloseHandler = (flag: string) => {
    setShow(false);
  };

  const tabs: TabItem[] = [
    {
      id: 1,
      key: 'countries',
      label: 'Countries',
      showCount: false,
    },
    {
      id: 2,
      key: 'stripeFees',
      label: 'Stripe Fees',
      showCount: false,
    },
    {
      id: 3,
      key: 'terms',
      label: 'Terms',
      showCount: false,
    },
  ];

  // Reset form state based on active tab
  const resetActiveFormState = () => {
    switch (activeTab) {
      case 'terms':
        termsCardRef.current?.resetFormState();
        break;
      case 'countries':
        countryCardRef.current?.resetFormState();
        break;
      default:
        break;
    }
  };

  const handleAddClick = () => {
    setShow(true);
    resetActiveFormState();
  };

  const components: Record<string, React.ReactNode> = {
    countries: (
      <CountryCard
        //ref={countryCardRef}
        onCloseHandler={onCloseHandler}
        showModal={show}
        setShowModal={setShow}
      />
    ),
    stripeFees: (
      <StripeFeeCard
        onCloseHandler={onCloseHandler}
        showModal={show}
        setShowModal={setShow}
      />
    ),
    terms: (
      <TermsCard
        ref={termsCardRef}
        onCloseHandler={onCloseHandler}
        showModal={show}
        setShowModal={setShow}
      />
    ),
  };

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey);
    setShow(false);
  };

  const getAddButtonText = () => {
    switch (activeTab) {
      case 'countries':
        return 'Add Country';
      case 'terms':
        return 'Add Terms';
      default:
        return 'Add';
    }
  };

  const showAddButton = activeTab !== 'stripeFees';

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <h1 className="fs-32 fw-700 mb-0 mt-0">Settings</h1>
        {loading && <Spinner animation="border" className="ms-2" size="sm" />}
      </div>
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between">
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
            className="settings-tabs"
          />
          <div>
            {showAddButton && (
              <StyledButton onClick={handleAddClick} className="text-white">
                {getAddButtonText()}
              </StyledButton>
            )}
          </div>
        </div>
        <div className="mt-4">{components[activeTab]}</div>
      </div>
    </div>
  );
};

export default Settings;
